import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import { BugReportModalComponent } from '../bug-report-modal/bug-report-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  organisationName$: Observable<string | undefined>;

  role$: Observable<string | undefined>;

  @ViewChild('bugReportModal') bugReportModal: BugReportModalComponent;

  constructor(protected api: ApiService, protected route: ActivatedRoute) {
    this.organisationName$ = api.user$.pipe(map(u => u?.organisationName));
    this.role$ = api.user$.pipe(map(u => u?.role));
  }

  ngOnInit() {
  }

  openBugReport() {
    this.bugReportModal.open();
  }

}
